const secondary = {
    social_bind_with: 'มีบัญชีอยู่แล้วใช่ไหม? ลงชื่อเข้าใช้เพื่อเชื่อมโยง {{methods, list(type: disjunction;)}} กับบัญชีโซเชียลของคุณ.',
};
export default Object.freeze(secondary);
